export const tabConfig = [
  {
    value: '1m',
    label: '1m',
  },
  {
    value: '5m',
    label: '5m',
  },
  {
    value: '1h',
    label: '1h',
  },
  {
    value: '4h',
    label: '4h',
  },
  {
    value: '1d',
    label: '24h',
  },
];
export type KlinePeriodTime = '1m' | '5m' | '1h' | '4h' | '1d';
